import { ApiGetRequest } from 'src/app/model/api/api-request/api-get-request';
import { ApiParameters } from 'src/app/model/api/api-request/api-parameters';

export class CompetitionWinnersRequest extends ApiGetRequest
{
    public constructor(competitionId: number, webapiBasepath: string)
    {
        super('competitionwinners', new ApiParameters().addQueryParameter("competitionId", competitionId), null, webapiBasepath);
    }
}
